import Swiper, { Navigation, Autoplay } from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.homepage-banner-carousel').forEach((carousel) => {
    const swiper = new Swiper(carousel.querySelector('.swiper-container'), {
      modules: [Navigation, Autoplay],
      autoHeight: true,
      slidesPerView: 1,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      watchOverflow: true,
      keyboard: true,
      a11y: {
        notificationClass: 'swiper-notification visually-hidden',
      },
      breakpoints: {
        992: {
          autoHeight: false
        }
      },
      navigation: {
        nextEl: '.carousel-next',
        prevEl: '.carousel-prev'
      },
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      on: {
        beforeResize: () => {
          // swiper-slide is height:100%, so without this the resize's autoHeight
          // recalc just reads back the stale wrapper height instead of the slide's own.
          swiper.wrapperEl.style.height = '';
        },
        beforeTransitionStart: () => {
          // Same stale-height issue as beforeResize, but for ordinary slide changes
          // (autoplay/arrows/swipe) instead of a window resize.
          swiper.wrapperEl.style.height = '';
        },
        init: () => {
          carousel.querySelector('.carousel-play').classList.add('d-none');
          carousel.querySelector('.carousel-pause').addEventListener('click', () => {
            swiper.autoplay.stop();
          })
          carousel.querySelector('.carousel-play').addEventListener('click', () => {
            swiper.autoplay.start();
          })
        },
        autoplayStop: () => {
          carousel.querySelector('.carousel-play').classList.remove('d-none');
          carousel.querySelector('.carousel-pause').classList.add('d-none');
        },
        autoplayStart: () => {
          carousel.querySelector('.carousel-play').classList.add('d-none');
          carousel.querySelector('.carousel-pause').classList.remove('d-none');
        },
        slidePrevTransitionStart: function() {
          var mindex = null;
          for (var key in this.slides) {
            var slide = this.slides[key];
            if (slide instanceof Element && slide.classList.contains('swiper-slide-visible')) {
              mindex = Math.max(mindex === null ? parseInt(key) : mindex, parseInt(key))
              slide.classList.add('swiper-slide-transitioning')
            }
          }
          if (mindex) {
            var leaving = this.slides[mindex + 1]
            if (leaving) {
              leaving.classList.add('swiper-slide-transitioning')
            }
          }
        },
        slideNextTransitionStart: function() {
          var mindex = null;
          for (var key in this.slides) {
            var slide = this.slides[key];
            if (slide instanceof Element && slide.classList.contains('swiper-slide-visible')) {
              mindex = Math.min(mindex === null ? parseInt(key) : mindex, parseInt(key));
              slide.classList.add('swiper-slide-transitioning')
            }
          }
          if (mindex) {
            var leaving = this.slides[mindex - 1]
            if (leaving) {
              leaving.classList.add('swiper-slide-transitioning')
            }
          }
        },
        slideChangeTransitionEnd: function() {
          for (var key in this.slides) {
            var slide = this.slides[key];
            if (slide instanceof Element && slide.classList.contains('swiper-slide-transitioning')) {
              slide.classList.remove('swiper-slide-transitioning')
            }
          }
        }
      }
    });

  })
})